import BasePage from "../../base/BasePage";
import NavBar from "../../components/navigation";
import React from "react";
import { addSchemaUseCase } from "../../usecases/schema/usecases";
import ProfilePresententer from "./ProfilePresenter";
import CardView from "../../components/common/CardView";
import RegionTab from "../../components/common/RegionTab";
import PersonalInfoPage from "./components/PersonalInfo/PersonalInfoPage";
import OtherInfoPage from "./components/OtherInfo/OtherInfoPage";
import withRouter from "../../withRouter";
import EmployeeInfoPage from "./components/EmployeeInfo/EmployeeInfoPage";
import PersonnelActionPage from "./components/PersonnelAction/PersonnelActionPage";
import PrintPDS from "./components/printPDS/PrintPDS";
import { Button, dialog, printComponent } from "nq-component";
import BaseListPage from "../../base/BaseListPage";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../usecases/object";
import PrintPDSTable from "./components/printPDS/PrintPDSTable";

class Profile extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new ProfilePresententer(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase(),
    );
    this.state = {
      object: {},
      employee: [],
      familyBackground: [],
      employeeName: "",
      position: "",
      employeeNo: "",
      hired: "",
      email: "",
      telmob: "",
      birthDate: "",
      birthPlace: "",
      sex: "",
      civil: "",
      citizenship: "",
      height: "",
      weight: "",
      blood: "",
      tin: "",
      gsis: "",
      sss: "",
      philhealth: "",
      pagIbig: "",
      residentialAdd: "",
      permanentAdd: "",
      picture: "",
      educationalBackground: [],
      workExperienceBackground: [],
      spouseName: "",
      spouseoccupation: "",
      spouseemployer: "",
      spouseaddress: "",
      spousetelNo: "",
      motherName: "",
      fatherName: "",
      voluntaryWorkBackground: [],
      learningDevBackground: [],
      civilServiceBackground: [],
      otherInformationBackground: [],
      diploma: [],
      certificate: [],
      certificateOfEligibility: [],
      workExp: [],
      birthCert: [],
      nbiClearance: [],
      socialInsurance: [],
      medicalHistory: [],
      referenceBackground: [],
      roles: [],
      filterCommittee: [],
    };
    this.contractPDF = React.createRef();
  }

  getObjectId() {
    return this.props.params && this.props.params.id;
  }

  async componentDidMount() {
    this.presenter.componentDidMount();
    const currentUser = this.getCurrentUser();
    this.presenter.employeeUpdate(this.getObjectId.bind(this), currentUser);
  }

  async componentDidUpdate(prevProps) {
    const email = this.getCurrentUser().username;
    if (prevProps.params.id !== this.props.params.id) {
      this.presenter.employeeUpdate(this.getObjectId.bind(this), email);
    }
  }

  getCollectionName() {
    return "employees";
  }
  // handlePrintPDS() {
  //   printComponent(this.contractPDF.current, "Tasks");
  // }

  // handlePrintPDS() {
  //   // const employeeData = this.state;
  //   // PrintPDS({ employeeData });
  //   printComponent(this.contractPDF.current, "Tasks");
  // }

  confirmEditingProfile() {
    this.dialogClose();
    this.navigateTo(`/form/employees/${this.getCurrentUser().employee.id}`);
  }

  dialogClose() {
    dialog.close();
  }

  handleEditProfile() {
    dialog.fire({
      html: (
        <div className="p-2">
          <div className="row">
            <h4>Edit Profile Confirmation</h4>
            <hr />
            <p style={{ fontSize: "13px", padding: "1rem" }}>
              Click continue to proceed in editing profile details.
            </p>
            <hr />
          </div>

          <div className="w-100 d-flex justify-content-end gap-4 pe-3 pb-3">
            <Button
              className="btn btn-light fs-sm"
              onClick={() => this.dialogClose()}
            >
              Cancel
            </Button>
            <Button
              className="btn btn-primary"
              onClick={this.confirmEditingProfile.bind(this)}
            >
              Confirm
            </Button>
          </div>
        </div>
      ),
      footer: false,
    });
  }
  // renderReport() {
  //   return <PrintPDS />;
  // }

  render() {
    const {
      employeeName,
      position,
      employeeNo,
      hired,
      email,
      telmob,
      birthDate,
      birthPlace,
      sex,
      civil,
      citizenship,
      height,
      weight,
      blood,
      tin,
      gsis,
      sss,
      philhealth,
      pagIbig,
      residentialAdd,
      permanentAdd,
      picture,
      educationalBackground,
      workExperienceBackground,
      spouseName,
      spouseoccupation,
      spouseemployer,
      spouseaddress,
      spousetelNo,
      motherName,
      fatherName,
      voluntaryWorkBackground,
      learningDevBackground,
      civilServiceBackground,
      otherInformationBackground,
      personalDataSheet,
      appointment,
      positionDescriptionFrom,
      oathOfOffice,
      serviceRecord,
      AssumptionOfDuty,
      contractOfService,
      copiesOfCertificatedEligibilities,
      copiesOfDiploma,
      copyOfBirth,
      medicalCertificated,
      nbiClearance,
      NoticeOfSalaryAdjustments,
      personalOrders,
      letterDirective,
      travelOrders,
      copiesOfDisciplinaryActions,
      individualPerformance,
      swornStatementOfAssets,
      othersFile,
      roles,
      filterCommittee,
    } = this.state;
    const tabs = [
      {
        title: "Personal Data Sheet",
        content: (
          <div>
            <PersonalInfoPage
              birthDate={birthDate}
              birthPlace={birthPlace}
              sex={sex}
              civil={civil}
              citizenship={citizenship}
              height={height}
              weight={weight}
              blood={blood}
              tin={tin}
              gsis={gsis}
              sss={sss}
              philhealth={philhealth}
              pagIbig={pagIbig}
              residentialAdd={residentialAdd}
              permanentAdd={permanentAdd}
              educationalBackground={educationalBackground}
              workExperienceBackground={workExperienceBackground}
            />
            <OtherInfoPage
              educationalBackground={educationalBackground}
              birthPlace={birthPlace}
              spouseName={spouseName}
              spouseoccupation={spouseoccupation}
              spouseemployer={spouseemployer}
              spouseaddress={spouseaddress}
              spousetelNo={spousetelNo}
              motherName={motherName}
              fatherName={fatherName}
              voluntaryWorkBackground={voluntaryWorkBackground}
              learningDevBackground={learningDevBackground}
              civilServiceBackground={civilServiceBackground}
              otherInformationBackground={otherInformationBackground}
              // diploma={diploma}
              // certificate={certificate}
              // certificateOfEligibility={certificateOfEligibility}
              // workExp={workExp}
              // birthCert={birthCert}
              // nbiClearance={nbiClearance}
              // socialInsurance={socialInsurance}
              // medicalHistory={medicalHistory}
              personalDataSheet={personalDataSheet}
              appointment={appointment}
              positionDescriptionFrom={positionDescriptionFrom}
              oathOfOffice={oathOfOffice}
              serviceRecord={serviceRecord}
              AssumptionOfDuty={AssumptionOfDuty}
              contractOfService={contractOfService}
              copiesOfCertificatedEligibilities={
                copiesOfCertificatedEligibilities
              }
              copiesOfDiploma={copiesOfDiploma}
              copyOfBirth={copyOfBirth}
              medicalCertificated={medicalCertificated}
              nbiClearance={nbiClearance}
              NoticeOfSalaryAdjustments={NoticeOfSalaryAdjustments}
              personalOrders={personalOrders}
              letterDirective={letterDirective}
              travelOrders={travelOrders}
              copiesOfDisciplinaryActions={copiesOfDisciplinaryActions}
              individualPerformance={individualPerformance}
              swornStatementOfAssets={swornStatementOfAssets}
              othersFile={othersFile}
              filterCommittee={filterCommittee}
            />
          </div>
        ),
      },
      {
        title: "Employee 201 Records ",
        content: (
          <div>
            <EmployeeInfoPage employee={this.state.employee} />
          </div>
        ),
      },
      {
        title: "Other Personnel Action ",
        content: (
          <div>
            <PersonnelActionPage employee={this.state.employee} />
          </div>
        ),
      },
    ];
    const user = this.getCurrentUser();
    const userRoles = this.getCurrentRoles()[0].id;
    const tabContents = tabs.map((tab) => tab.content);
    return (
      <>
        {/* <div className="d-none mt-5">
          <div ref={this.contractPDF} id="contractPDF" className="mt-5 ms-4">
            <PrintPDSTable object={this.state} />
          </div>
        </div> */}
        <div
          className="container-fluid d-flex flex-column p-5"
          style={{ marginTop: "4rem" }}
        >
          <div
            className="d-flex mb-4"
            style={{ borderBottom: "1px solid #d3d3d3" }}
          >
            <p style={{ fontSize: "14px", color: "grey" }}>
              You are here:My Profile
            </p>
          </div>

          <div className="row">
            <div className="col-lg-12 mb-3">
              <CardView>
                <div className="p-lg-3 mb-lg-4 ">
                  <div className="d-lg-flex flex-lg-row flex-lg-wrap justify-content-start align-items-center">
                    <div className="mb-3 mb-lg-0 mr-lg-4">
                      <div className="d-flex justify-content-center justify-content-lg-start">
                        <div
                          style={{
                            width: "150px",
                            height: "150px",
                            backgroundColor: "#ccc",
                            borderRadius: "5px",
                            whiteSpace: "nowrap",
                            color: "white",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <p style={{ fontSize: "4.5rem", margin: 0 }}>
                            {picture ? (
                              <img
                                className="w-100 h-100 object-fit-cover"
                                // style={{ width: "10rem" }}
                                src={picture}
                                alt="Profile"
                              />
                            ) : (
                              user.username.substring(0, 2).toUpperCase()
                            )}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div style={{ lineHeight: 1.2, marginLeft: ".8rem" }}>
                      <p style={{ fontWeight: "bold", fontSize: "1.4rem" }}>
                        {employeeName}
                      </p>
                      <div
                        className="text-left"
                        style={{ color: "grey", fontSize: "12px" }}
                      >
                        {<p className="mb-1">{roles.join(", ")}</p>}
                        {/* <p className="mb-1">{roles}</p> */}
                        <p className="mb-1">
                          Position: {position?.position_title || "-"}
                        </p>
                        <p className="mb-1">Employee No: {employeeNo}</p>
                        <p className="mb-1">Assumption Date: {hired}</p>
                        <p className="mb-1">Email: {email}</p>
                        <p className="mb-1">Mobile/ Telephone No: {telmob}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </CardView>
            </div>
            <div className="col-lg-12 mb-3">
              <CardView>
                <RegionTab
                  tabs={tabs}
                  tabContents={tabContents}
                  tabButtons={
                    <div>
                      {/* {this.getObjectId() === undefined && ( */}
                      {/* <button
                        style={{
                          marginRight: "5px",
                          backgroundColor: "#29457c",
                          color: "#fff",
                          fontSize: "13px",
                          padding: "5px 15px",
                          border: "none",
                          borderRadius: "4px",
                        }}
                        onClick={() => this.handleEditProfile()}
                      >
                        Edit Profile
                      </button> */}
                      {/* )} */}

                      {/* {this.getObjectId() !== undefined && ( */}
                      <button
                        style={{
                          backgroundColor: "#29457c",
                          color: "#fff",
                          fontSize: "13px",
                          padding: "5px 15px",
                          border: "none",
                          borderRadius: "4px",
                        }}
                        onClick={() => this.presenter.PrintPDS()}
                      >
                        Print PDS
                      </button>
                      {/* )} */}
                    </div>
                  }
                />
              </CardView>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(Profile);
